import { ENVIRONMENT_BASE } from "./default";

export const environment = {
  production: false,
  ...ENVIRONMENT_BASE,
};
